import { defineStore } from "pinia";
import { GET_FOOTER,GET_MODULE,PREFERENCES,GET_MODULE_SECTION } from "@/api/apiRoute";
import { handleApiResponse, handleError } from "@/utils/common.js";
import { authData } from "@/api/apiService.js";

export const useRightPanelStore = defineStore("rightPanel", {
  state: () => ({
    isRightPanelVisible: false,
    footerData: null,
    loading: false,
    moduleData: null,
    preferencesData: null,
    isShowTour: null,
  }),
  actions: {
    toggleRightPanel() {
      this.isRightPanelVisible = !this.isRightPanelVisible;
    },
    showRightPanel() {
      this.isRightPanelVisible = true;
    },
    hideRightPanel() {
      this.isRightPanelVisible = false;
    },
    setErrorMessage(message) {
      this.errorMessage = message;
    },
    clearErrorMessage() {
      this.errorMessage = "";
    },
    async getFooterData() {
      this.loading = true;
      try {
        const response = await authData.get(GET_FOOTER);
        this.footerData = response.data.data;
        return handleApiResponse(response);
      } catch (error) {
        this.setErrorMessage(
          error?.errorMessage || error?.message || "An error occurred"
        );
        return handleError(error);
      } finally {
        this.loading = false;
      }
    },
    async getModulesData(forceRefresh = false) {
      if (!forceRefresh && this.moduleData) {
        return { success: true, data: { data: this.moduleData } };
      }

      this.loading = true;
      try {
        const response = await authData.get(GET_MODULE);
        this.moduleData = response.data.data;
        return handleApiResponse(response);
      } catch (error) {
        this.setErrorMessage(
          error?.errorMessage || error?.message || "An error occurred"
        );
        return handleError(error);
      } finally {
        this.loading = false;
      }
    },
    async getsectionData(){
      this.loading = true;
      try {
        const response = await authData.get(GET_MODULE_SECTION('estate'));
        return handleApiResponse(response);
      } catch (error) {
        this.setErrorMessage(
          error?.errorMessage || error?.message || "An error occurred"
        );
        return handleError(error);
      } finally {
        this.loading = false;
      }
    },
    async getPreferences(){
      this.loading = true;
      try {
        const response = await authData.get(PREFERENCES);
        this.preferencesData = response.data.data;
        return handleApiResponse(response);
      } catch (error) {
        this.setErrorMessage(
          error?.errorMessage || error?.message || "An error occurred"
        );
        return handleError(error);
      } finally {
        this.loading = false;
      }
    },
    async updatePreferences(payload){
      this.loading = true;
      try {
        const response = await authData.patch(PREFERENCES,payload)
        return handleApiResponse(response);
      } catch (error) {
        this.setErrorMessage(
          error?.errorMessage || error?.message || "An error occurred"
        );
        return handleError(error);
      } finally {
        this.loading = false;
      }
    },
  },
});

export const useSidebarStore = defineStore("sidebar", {
  state: () => ({
    isSidebarCollapsed: false,
  }),
  actions: {
    toggleSidebar() {
      this.isSidebarCollapsed = !this.isSidebarCollapsed;
    },
  },
});
